import React, {Component, Fragment} from "react";
import EmphasizeText from "../../components/EmphasizeText";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Divider, Dropdown, Menu, Modal} from "antd";
import StandardTable from "../../components/StandardTable";
import * as keywordApi from "../../api/keyword";
import ProcessSubmit from "../report-order/processSubmit";
import * as api from "../../api/order_process";

class MyOrder extends Component {

    dataTable = null

    state = {
        keywords: [],

        submitModalVisible: false,
        submitModalSaving: false,
        submitModalRecord: null,

        columns: [
            {
                dataIndex: 'index',
                render: (text, record, index) => index + 1,
                fixed: 'left'
            },
            {
                title: '产品ID',
                dataIndex: 'product_no',
                key: 'product_no',
                sorter: true
            },
            {
                title: '采购单号',
                dataIndex: 'purchase_no',
                key: 'purchase_no',
                sorter: true
            },
            {
                title: '行号',
                dataIndex: 'line_no',
                key: 'line_no',
                sorter: true
            },
            {
                title: '版本',
                dataIndex: 'version_no',
                key: 'version_no',
                sorter: true
            },
            {
                title: '客户物料ID',
                dataIndex: 'product_id',
                key: 'product_id',
            },
            {
                title: '上道工序',
                dataIndex: 'process_description',
                key: 'process_description',
            },
            {
                title: '当前工序',
                dataIndex: 'next_process_description',
                key: 'next_process_description',
            },
            {
                title: '物料描述',
                dataIndex: 'product_description',
                key: 'product_description',
                render: (record) => (<EmphasizeText keywords={this.state.keywords}>{record}</EmphasizeText>)
            },
            {
                title: '单位',
                dataIndex: 'unit_name',
                key: 'unit_name',
            },
            {
                title: '数量',
                dataIndex: 'qty',
                key: 'qty',
            },
            {
                title: '计划发货日期',
                dataIndex: 'plan_delivery_date',
                key: 'plan_delivery_date',
                sorter: true
            },
            {
                title: '交货日期',
                dataIndex: 'delivery_date',
                key: 'delivery_date',
                sorter: true
            },
            {
                title: '发货数量',
                dataIndex: 'delivery_qty',
                key: 'delivery_qty',
            },
            {
                title: '库存地点',
                dataIndex: 'stock_place',
                key: 'stock_place',
            },
            {
                title: '销售订单',
                dataIndex: 'sale_no',
                key: 'sale_no',
            },
            {
                title: '材料描述',
                dataIndex: 'material_description',
                key: 'material_description',
            },
            {
                title: '检验文本',
                dataIndex: 'check_text',
                key: 'check_text',
            },
            {
                title: '材料短描述',
                dataIndex: 'product_short_description',
                key: 'product_short_description',
                render: (record) => (<EmphasizeText keywords={this.state.keywords}>{record}</EmphasizeText>)
            },
            {
                title: '确认日期',
                dataIndex: 'confirm_date',
                key: 'confirm_date',
            },
            {
                title: '产品类别',
                dataIndex: 'category_name',
                key: 'category_name',
            },
            {
                title: '刀模编号',
                dataIndex: 'die_no',
                key: 'die_no',
            },
            {
                title: '生产工序',
                dataIndex: 'process_group_name'
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '',
                fixed: 'right',
                key: 'operate',
                render: (record) => {
                    return (
                        <span>
                            <a onClick={() => this.handleSubmitModalShow(record)}>工序</a>
                            {record.pdf_path &&
                            <Fragment>
                                <Divider type={'vertical'} />
                                <a onClick={() => window.open(record.pdf_path)}>产品ID图纸</a>
                            </Fragment>
                            }
                            {record.drawing_path &&
                            <Fragment>
                                <Divider type={'vertical'} />
                                <a onClick={() => window.open(record.drawing_path)}>生产图纸</a>
                            </Fragment>
                            }
                            {record.picture_path &&
                            <Fragment>
                                <Divider type={'vertical'} />
                                <a onClick={() => window.open(record.picture_path)}>图片图纸</a>
                            </Fragment>
                            }
                            {record.die_path &&
                            <Fragment>
                                <Divider type={'vertical'} />
                                <a onClick={() => window.open(record.die_path)}>刀模</a>
                            </Fragment>
                            }
                    </span>
                    )
                }
            }
        ]
    }

    componentDidMount() {
        keywordApi.getKeywords().then(({data}) => {
            this.setState({
                keywords: data.data,
            });
        });
    };

    handleSubmitModalShow = (record) => {
        this.setState({
            submitModalVisible: true,
            submitModalRecord: record,
        })
    };

    handleSubmitModalOk = (fieldsValue) => {
        const orderId = this.state.submitModalRecord.id
        const processId = this.state.submitModalRecord['next_process_id'];
        const value = fieldsValue.qty;

        this.setState({submitModalSaving: true});
        api.submitOrderProcessValue(processId, value, orderId).then(() => {
            this.dataTable.fetch()
            this.setState({submitModalSaving: false, submitModalVisible: false});
        }).catch(() => {
            this.setState({submitModalSaving: false});
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'我的订单'}>
                <Card>
                    <StandardTable columns={this.state.columns}
                                   url={'/api/my/order/'}
                                   rowKey={'id'}
                                   scroll={{x: 'max-content'}}
                                   ref={(table) => this.dataTable = table}
                    />
                </Card>
                <ProcessSubmit visible={this.state.submitModalVisible}
                               confirmLoading={this.state.submitModalSaving}
                               onOk={this.handleSubmitModalOk}
                               onCancel={() => this.setState({submitModalVisible: false})}
                />
            </PageHeaderLayout>
        );
    }
}

export default MyOrder;